import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ImportWizard from './ConsignmentImportWizard';
const ConsignmentImportPage = () => {
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article", children: [_jsx("h2", { className: "article-title", children: "Import Deliveries" }), _jsx(ImportWizard, {})] }) }));
};
export default ConsignmentImportPage;
